import React from 'react'
import classNames from 'classnames'
import BrowseMenu from '../../BrowseMenu'
import { ContainedNavItemProps } from '../'
import styles from '../styles.css'

const BrowseNavItem: React.FC<ContainedNavItemProps> = ({
  children,
  onNavItemMouseEnter,
  onNavItemMouseLeave,
  isNavItemHovered
}) => {
  return (
    <li
      data-testid="desktop-browse-menu-trigger"
      className={styles.browseNavItem}
      onMouseEnter={() => {
        onNavItemMouseEnter()
      }}
      onMouseLeave={() => {
        onNavItemMouseLeave()
      }}
    >
      <span
        className={classNames(styles.navItemLink, {
          [styles.navItemLinkHovered]: isNavItemHovered
        })}
      >
        <div className={styles.navItemHighlight}>{children}</div>
      </span>
      <div
        className={classNames(styles.menuContent, {
          [styles.visible]: isNavItemHovered
        })}
      >
        <BrowseMenu isVisible={isNavItemHovered} />
      </div>
    </li>
  )
}

export default BrowseNavItem
